import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getTcsmEpiProps, setNewHireSettings } from '../../../../../global/ducks/epi-api';
import { TcsmEpiApiState, TcsmStates } from '../../../../../root/tcsm-model';

export function useNewHireSettings(newHireSettingsId: string) {
	const dispatch = useDispatch();
	const epiApiState = useSelector<TcsmStates, TcsmEpiApiState>(state => state.epiProps);
	const language = useSelector<TcsmStates, string>(state => state.globalization.currentlanguage);
	const guid = useSelector<TcsmStates, string>(state => state.authenticatedState?.clientGuid);

	useEffect(() => {
		if (!epiApiState?.newHireSettingsState?.contentLoaded) {
			dispatch(getTcsmEpiProps(dispatch, newHireSettingsId, { guid }, language, false, setNewHireSettings));
		}
	}, []);

	return epiApiState?.newHireSettingsState?.contentLoaded;
}